import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { Validators } from "@angular/forms";
import * as moment from "moment";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Branch, form_control, Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { AuthService, isNullOrUndefined, LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { DBkeys } from "projects/sepidz-web-framework/src/lib/services/db-keys";
import { take } from "rxjs/operators";
import { PaymentMethodType } from "src/app/frontoffice/financial/model/payment-method.enum";
import {
  BranchList,
  SaleMethodBranchCustomerCategory,
  SaleMethodBranchItemCategory,
  SaleMethodBranchModel,
  SaleMethodBranchPaymentMethod,
  SaleMethodBranchPrintTemplate,
  SaleMethodBranchSalePriceType,
  SaleMethodBranchSalon,
  SaleMethodNature,
} from "../../model/sale-method-branch.model";

@Component({
  selector: "ngx-sale-method-branch-form",
  templateUrl: "./sale-method-branch-form.html",
  styleUrls: ["./sale-method-branch-form.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaleMethodBranchForm extends BaseFormComponent<SaleMethodBranchModel> implements AfterViewChecked {
  _DBkeys = DBkeys;
  ItemCategoryLookup: Lookup[] = [];
  ItemCategory: Lookup[] = [];
  ItemCategoriesDefaultList: Lookup[] = [];
  SaleMethodList: Lookup[] = [];
  PaymentMethodLookup: Lookup[] = [];
  PaymentMethod: Lookup[] = [];
  PaymentMethodDefaultList: Lookup[] = [];
  SalePriceTypeLookup: Lookup[] = [];
  SalePriceType: Lookup[] = [];
  SalePriceTypeDefaultList: Lookup[] = [];
  PrintTemplateLookup: Lookup[] = [];
  PrintTemplate: Lookup[] = [];
  PrintTemplateDefaultList: Lookup[] = [];
  oldmodel: SaleMethodBranchModel[] = [];
  SalonLookupList: Lookup[] = [];
  DetailLedgerLookupList: Lookup[] = [];
  erroremessage: string;
  ItemCategoryIdList: number[] = [];
  ItemCategoriesDefaultId: number;
  PaymentMethodIdList: number[] = [];
  PaymentMethodDefaultId: number;
  SalePriceTypeIdList: number[] = [];
  SalePriceTypeDefaultId: number;
  PrintTemplateIdList: number[] = [];
  SalonLookup: number[] = [];
  CustomerCategoriesLookup: number[] = [];
  SaleMethodNatureId: number;
  oldSaleMethodNatureId: number;
  SaleMethodNatureCode: number;
  oldformGroup: any;
  isStartGetData: boolean = false;
  activeTabTitle: string;
  _saleMethodNature: typeof SaleMethodNature = SaleMethodNature;
  isAccessToAllBranches = true;
  Branches: BranchList[] = [];
  DefaultValues: Dictionary = [];
  branchShow: boolean = false;
  HasHappyHour: boolean = false;
  ShowDescInvCustomer: boolean = false;
  ShowDescInvKitchen: boolean = false;
  Branchescolumns: form_control[] = [];
  SoftWareLicenseKind = SoftWareLicenseKind;
  HasAccessOrderOnline: boolean;
  delinoActiveControl: SaleMethodBranchModel[];
  controlIdDelino: number;
  PaymentMethodData: any[] = [];
  IsActivePreparationTime: boolean = false;
  hasInv: boolean;
  invalidHourDiscount: boolean = false;
  depositVisibilityIsCalled: boolean;
  currentInformation = this.accountService.authService.currentInformation();
  currentBranch = this.accountService.authService.currentBranch;

  DaysOfWeekList = [
    { Id: "0", Title: this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Saturday") },
    { Id: "1", Title: this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Sunday") },
    { Id: "2", Title: this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Monday") },
    { Id: "3", Title: this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Tuesday") },
    { Id: "4", Title: this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Wednesday") },
    { Id: "5", Title: this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Thursday") },
    { Id: "6", Title: this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Friday") },
  ];
  hasReserved: boolean;
  OriginalApplyTax: boolean;
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public storage: LocalStoreManager,
    public authservice: AuthService
  ) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.getRelative();
    this.FillData();
    this.apiName = "SaleMethodBranch";
    this.label = this.translate("ClientApp.FrontOffice.SALE.SaleMethod.SaleMethodBranch");
    super.ngOnInit();
    this.controlActiveDelino();
    this.getAccessDelino();
    this.DefaultValues["SaleMethodBranchId"] = 0;
    const firstcol = new form_control();
    firstcol.name = "IsActive";
    firstcol.controlType = FormControlTypes.checkbox;
    firstcol.label = this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Includes");
    firstcol.areaName = "default";
    firstcol.listVisible = true;
    firstcol.columnWidth = 100;
    firstcol.decimalsLength = 100;
    firstcol.textType = "checkbox";
    firstcol.disabled = false;
    firstcol.formVisible = true;
    this.Branchescolumns.push(firstcol);
    const secondcol = new form_control();
    secondcol.label = this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Branch");
    secondcol.areaName = "default";
    secondcol.name = "Title";
    secondcol.listVisible = true;
    secondcol.columnWidth = 500;
    secondcol.decimalsLength = 500;
    secondcol.controlType = FormControlTypes.textbox;
    secondcol.disabled = true;

    this.Branchescolumns.push(secondcol);
    this.hasInv = !!this.currentInformation.InventoryKind;
    this.OriginalApplyTax = this.currentrow.ApplyTax;
  }

  ngAfterViewChecked(): void {
    const controls = this.formGroup.controls;
    if (!this.currentInformation?.HasClub) {
      if (this.currentInformation.SmartEvaluation) {
        controls["IsClubFastAccess"]?.enable();
      } else {
        controls["IsClubFastAccess"]?.disable();
      }
    }

    if (!this.currentInformation?.PaymentPanelAVA) {
      controls["IsPaymentLink"]?.disable();
    }
    if (!this.formGroup?.value?.HasFactorLink || !this.formGroup?.value?.HasPaymentLinkForNewCustomer) {
      controls["PrintForOnlineOrderForNewCustomer"]?.disable();
    }
    if (!this.formGroup?.value?.HasFactorLink) {
      controls["HasPaymentLinkForNewCustomer"]?.disable();
      controls["AutomaticLinks"]?.disable();
    }
    if (!this.formGroup?.value?.HasFactorLink || !this.currentInformation?.PaymentPanelAVA) {
      controls["HasPaymentLink"]?.disable();
    }
    if (!this.currentInformation?.OrderServices) {
      controls.HasDeposit.disable();
    } else if (this.model.Id && this.formGroup?.value?.HasDeposit && !this.depositVisibilityIsCalled) {
      this.depositVisibilityIsCalled = true;
      this.httpCommonService
        .get("SaleMethodBranch/DepositVisibility/" + this.model.Id)
        .pipe(take(1))
        .subscribe((isVisible) => {
          if (isVisible) controls.HasDeposit.enable();
          else controls.HasDeposit.disable();
        });
    }
  }

  setdefault() {
    if (!this.model.Branches) this.model.Branches = [];
    if (this.SaleMethodList?.length <= 0 && !this.isStartGetData) {
      this.isStartGetData = true;
      this.httpCommonService
        .getList(`SaleMethod/ReadSaleMethodLookUpFilter/${this.model?.Id}/${this.accountService.authService.currentBranchId}`)
        .pipe(take(1))
        .subscribe((data: Lookup[]) => {
          if (data) this.SaleMethodList = data;
          this.isStartGetData = false;
          this.cd.markForCheck();
        });
    }
    this.HasHappyHour = this.model.HasHappyHour;
    this.IsActivePreparationTime = this.model.PreprationTimeIsActive;
    this.oldmodel = JSON.parse(JSON.stringify(this.model));
    if (!this.model.ItemCategories) this.model.ItemCategories = [];
    else {
      this.model.ItemCategories?.forEach((x) => {
        if (!x.IsDefault) this.ItemCategoryIdList.push(x.CategoryId);
      });
    }
    if (!this.model.PaymentMethods) this.model.PaymentMethods = [];
    else {
      this.model.PaymentMethods?.forEach((x) => {
        if (!x.IsDefault) this.PaymentMethodIdList.push(x.PaymentMethodId);
      });
    }
    if (!this.model.PrintTemplates) this.model.PrintTemplates = [];
    else {
      this.model.PrintTemplates?.forEach((x) => {
        if (!x.IsDefault) this.PrintTemplateIdList.push(x.PrintTemplateId);
      });
    }
    if (!this.model.SalePriceTypes) this.model.SalePriceTypes = [];
    else {
      this.model.SalePriceTypes?.forEach((x) => {
        if (!x.IsDefault) this.SalePriceTypeIdList.push(x.SalePriceTypeId);
      });
    }

    if (!this.model.Salons) this.model.Salons = [];
    else this.model.Salons?.forEach((x) => this.SalonLookup.push(x.SalonId));

    if (!this.model.CustomerCategories) this.model.CustomerCategories = [];
    else {
      this.model.CustomerCategories?.forEach((x) => this.CustomerCategoriesLookup.push(x.CategoryId));
    }
    //new mode
    if (isNullOrUndefined(this.model.Id) || this.model.Id === 0) this.model.IsActive = true;
    //edit mode
    else {
      this.SaleMethodNatureCode = this.model.SaleMethod.SaleMethodNatureCode;
      this.oldSaleMethodNatureId = this.model.SaleMethod.SaleMethodNatureId;
    }
    if (this.currentrow && this.model.DaysOfWeek && typeof this.model.DaysOfWeek === "string") {
      this.model.DaysOfWeek = this.model.DaysOfWeek.split(",");
    }
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    this.orignalColumns?.forEach((x) => {
      if (x.name === "DetailLedgerId")
        x.formVisible =
          this.currentInformation.AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
          this.currentInformation.AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb;
      if (x.name === "GoodsId")
        x.formVisible =
          this.currentInformation.InventoryKind === SoftWareLicenseKind.InventoryWeb ||
          this.currentInformation.InventoryKind === SoftWareLicenseKind.InventoryAdvancedWeb ||
          this.currentInformation.InventoryKind === SoftWareLicenseKind.InventoryToAdvancedWeb;
    });
    this.cd.markForCheck();
  }

  addControl() {
    this.setValue("ApplyTax", this.model.ApplyTax);
    this.setValue("TaxApplyIsChanged", null);
    this.setValue("ApplyService", this.model.ApplyService);
    this.setValue("WaiterIsRequired", this.model.WaiterIsRequired);
    this.setValue("HasKeyboardOrder", this.model.HasKeyboardOrder);
    this.setValue("HasHappyHour", this.model.HasHappyHour);
    this.setValue("ShowDescInvKitchen", this.model.ShowDescInvKitchen);
    this.setValue("ShowDescInvCustomer", this.model.ShowDescInvCustomer);
    this.setValue("HappyHourStart", this.model.HappyHourStart ? moment(this.model.HappyHourStart).format("HH:mm") : null);
    this.setValue("HappyHourEnd", this.model.HappyHourEnd ? moment(this.model.HappyHourEnd).format("HH:mm") : null);
    this.setValue("HappyHourFromDate", this.model.HappyHourFromDate ? moment(this.model.HappyHourFromDate).locale("fa").format("YYYY/MM/DD") : null);
    this.setValue("HappyHourToDate", this.model.HappyHourToDate ? moment(this.model.HappyHourToDate).locale("fa").format("YYYY/MM/DD") : null);
    this.setValue("DaysOfWeek", this.model.DaysOfWeek);
    this.setValue("Discount", this.model.Discount);
    this.formGroup?.controls["Discount"].setValue(this.model.Discount);
    this.setValue("FreeShipping", this.model.FreeShipping);
    this.setValue("FreeService", this.model.FreeService);
    this.setValue("IncludeFreeItemDependency", this.model.IncludeFreeItemDependency);
    this.setValue("IncludeItemDependency", this.model.IncludeItemDependency);
    this.setValue("ApplyTaxForService", this.model.ApplyTaxForService);
    this.setValue("IsBarCodeInvoice", this.model.IsBarCodeInvoice);
    this.setValue("HasDeposit", this.model.HasDeposit);
    this.setValue("ApplyTaxForPackingPrice", this.model.ApplyTaxForPackingPrice);
    this.setValue("ApplyPackingPrice", this.model.ApplyPackingPrice);
    this.setValue("HasSnap", this.model.HasSnap);
    this.setValue("AutoApplySnap", this.model.AutoApplySnap);
    this.setValue("ApplyTaxForShippingCost", this.model.ApplyTaxForShippingCost);
    this.setValue("TableIsRequired", this.model.TableIsRequired);
    this.setValue("NumberOfGuestsIsRequired", this.model.NumberOfGuestsIsRequired);
    this.setValue("ShowSalonName", this.model.ShowSalonName);
    this.setValue("HasNecessaryMobile", this.model.HasNecessaryMobile);
    this.setValue("ShowCustomerInfo", this.model.ShowCustomerInfo);
    this.setValue("ShowWaiterName", this.model.ShowWaiterName);
    this.setValue("ShowNumberOfGuests", this.model.ShowNumberOfGuests);
    this.setValue("MaximumTimeForStay", this.model.MaximumTimeForStay);
    this.setValue("HasNecessaryName", this.model.HasNecessaryName);
    this.setValue("UseMobileInValidation", this.model.UseMobileInValidation);
    this.setValue("PaymentMethodIdList", this.PaymentMethodIdList);
    this.setValue("ItemCategoriesDefaultId", this.ItemCategoriesDefaultId);
    this.setValue("ItemCategoryIdList", this.ItemCategoryIdList);
    this.setValue("PaymentMethodDefaultId", this.PaymentMethodDefaultId);
    this.setValue("SalePriceTypeIdList", this.SalePriceTypeIdList);
    this.setValue("SalePriceTypeDefaultId", this.SalePriceTypeDefaultId);
    this.setValue("PrintTemplateIdList", this.PrintTemplateIdList);
    this.setValue("SalonLookup", this.SalonLookup);
    this.setValue("CustomerCategoriesLookup", this.CustomerCategoriesLookup);
    this.setValue("IsChangeTheSalesMethod", this.model.IsChangeTheSalesMethod);
    this.setValue("IsSalonFastAccess", this.model.IsSalonFastAccess);
    this.setValue("IsDriverAssignmentFastAccess", this.model.IsDriverAssignmentFastAccess);
    this.setValue("IsCustomreFastAccess", this.model.IsCustomreFastAccess);
    this.setValue("IsWaiterFastAccess", this.model.IsWaiterFastAccess);
    this.setValue("IsPagerFastAccess", this.model.IsPagerFastAccess);
    this.setValue("IsClubFastAccess", this.model.IsClubFastAccess);
    this.setValue("IsPaymentLink", this.model.IsPaymentLink);
    this.setValue("SaleMethodId", this.model.SaleMethodId, true);
    this.setValue("HasFactorLink", this.model.HasFactorLink);
    this.setValue("HasPaymentLink", this.model.HasPaymentLink);
    this.setValue("HasDelinoOfflineFactor", this.model.HasDelinoOfflineFactor);
    this.setValue("AutomaticLinks", this.model.AutomaticLinks);
    this.setValue("HasPaymentLinkForNewCustomer", this.model.HasPaymentLinkForNewCustomer);
    this.setValue("PrintForOnlineOrder", this.model.PrintForOnlineOrder);
    this.setValue("PrintForOnlineOrderForNewCustomer", this.model.PrintForOnlineOrderForNewCustomer);
    this.setValue("PaymentId", this.model.PaymentId);
    this.setValue("PreprationTimeIsActive", this.model.PreprationTimeIsActive);
    this.setValue("PreprationTimeRequired", this.model.PreprationTimeRequired);
    this.setValue("InvVoucherId", this.model.InvVoucherId);
    this.setValue("InvWareHouseId", this.model.InvWareHouseId);
    this.setValue("InvDepositVoucherKindId", this.model.InvDepositVoucherKindId);
    this.setValue("InvDepositWareHouseId", this.model.InvDepositWareHouseId);
    this.setValue("BranchId", this.model.BranchId);

    const controls = this.formGroup.controls;
    if (this.HasAccessOrderOnline === false) controls["HasDelino"].disable();
    else controls["HasDelino"].enable();

    if (this.currentInformation?.SmartEvaluation && this.currentInformation?.ReservedKind) {
      controls["HasOnlineRezerv"].enable();
    } else {
      controls["HasOnlineRezerv"].disable();
    }
    this.cd.markForCheck();
  }

  waiterIsRequiredvalueChange($event) {
    this.setValue("ShowWaiterName", $event);
  }

  TableIsRequiredvalueChange($event) {
    this.setValue("ShowSalonName", $event);
  }

  NumberOfGuestsIsRequiredvalueChange($event) {
    this.setValue("ShowNumberOfGuests", $event);
  }

  delinoIsRequiredvalueChange($event) {
    this.setValue("HaspickupOrderOnline", $event);
  }

  clearHappyHourForm() {
    const controls = this.formGroup.controls;
    controls["Discount"].setValue(null);
    controls["HappyHourStart"].setValue(null);
    controls["HappyHourEnd"].setValue(null);
    controls["FreeService"].setValue(false);
    controls["FreeShipping"].setValue(false);
    controls["HappyHourFromDate"].setValue(null);
    controls["HappyHourToDate"].setValue(null);
    controls["DaysOfWeek"].setValue("");
  }

  HappyHourValueChange($event) {
    if ($event == false) this.clearHappyHourForm();
    this.HasHappyHour = $event;
  }

  HappyHourStratValueChange($event) {
    const start = $event;
    const end = this.formGroup.controls["HappyHourEnd"]?.value;
    if (typeof end == "string" && typeof end == "string" && start.split(":") > end.split(":")) {
      this.setValue("HappyHourEnd", start);
    }
  }

  HappyHourEndValueChange($event) {
    const start = this.formGroup.controls["HappyHourStart"]?.value;
    const end = $event;
    if (typeof end == "string" && typeof end == "string" && start.split(":") > end.split(":")) {
      this.setValue("HappyHourEnd", start);
    }
  }

  async FillData() {
    this.populateBranch();
    this.oldSaleMethodNatureId = null;
    this.model.Salons?.forEach((x) => {
      if (!this.SalonLookup.some((d) => d === x.SalonId)) this.SalonLookup.push(x.SalonId);
      this.SalonLookup = this.SalonLookup?.filter((d) => d !== null);
    });
    this.model.CustomerCategories?.forEach((x) => {
      if (!this.CustomerCategoriesLookup.some((d) => d === x.CategoryId)) this.CustomerCategoriesLookup.push(x.CategoryId);
      this.CustomerCategoriesLookup = this.CustomerCategoriesLookup?.filter((d) => d !== null);
    });
    this.setValue("SalonLookup", this.SalonLookup);
    this.setValue("CustomerCategoriesLookup", this.CustomerCategoriesLookup);
  }

  FillItemCategory(data: Lookup[]) {
    this.ItemCategory = data;
    this.ItemCategoryLookup = data;
    this.ItemCategoriesDefaultList = data;
    if (!isNullOrUndefined(this.currentrow.Id) || (this.currentrow.Id !== 0 && this.currentrow.ItemCategories)) {
      this.currentrow.ItemCategories?.forEach((x) => {
        if (!x.IsDefault) {
          if (!this.ItemCategoryIdList.some((d) => d === x.CategoryId)) this.ItemCategoryIdList.push(x.CategoryId);
          this.ItemCategoryIdList = this.ItemCategoryIdList?.filter((d) => d !== null);
          this.ItemCategoriesDefaultList = this.ItemCategoriesDefaultList?.filter((f) => f.Id !== x.CategoryId);
        } else {
          if (!isNullOrUndefined(x.CategoryId) && x.CategoryId !== 0) {
            this.ItemCategoriesDefaultId = x.CategoryId;
            this.ItemCategory = this.ItemCategory?.filter((f) => f.Id !== x.CategoryId);
          }
        }
      });
    }
    this.setValue("ItemCategoryIdList", this.ItemCategoryIdList);
    this.setValue("ItemCategoriesDefaultId", this.ItemCategoriesDefaultId);
  }

  onHasFactorChanges(value: boolean): void {
    const controls = this.formGroup.controls;
    if (!value) {
      this.setValue("HasPaymentLink", false);
      this.setValue("AutomaticLinks", false);
      this.setValue("PrintForOnlineOrder", false);
      this.setValue("HasPaymentLinkForNewCustomer", false);
      this.setValue("PrintForOnlineOrderForNewCustomer", false);
      controls["HasPaymentLink"]?.disable();
      controls["AutomaticLinks"]?.disable();
      controls["PrintForOnlineOrder"]?.disable();
      controls["HasPaymentLinkForNewCustomer"]?.disable();
      controls["PrintForOnlineOrderForNewCustomer"]?.disable();
    } else {
      controls["HasPaymentLink"]?.enable();
      controls["AutomaticLinks"]?.enable();
      controls["PrintForOnlineOrder"]?.enable();
      controls["HasPaymentLinkForNewCustomer"]?.enable();
      controls["PrintForOnlineOrderForNewCustomer"]?.enable();
    }
  }

  onInPersonChanges(value: boolean) {
    const controls = this.formGroup.controls;
    if (!!value) {
      this.model.HasSnap = false;
      controls["HasSnap"]?.setValue(false);
      controls["HasSnap"]?.disable();
      this.model.AutoApplySnap = false;
      controls["AutoApplySnap"]?.setValue(false);
      controls["AutoApplySnap"]?.disable();
    } else {
      controls["HasSnap"]?.enable();
    }
  }

  onApplySnap(value: boolean) {
    const controls = this.formGroup.controls;
    if (!!value) {
      this.model.InPerson = false;
      controls["InPerson"]?.setValue(false);
      controls["InPerson"]?.disable();
      controls["AutoApplySnap"]?.enable();
    } else {
      this.model.AutoApplySnap = false;
      controls["InPerson"]?.enable();
      controls["AutoApplySnap"]?.disable();
    }
  }

  onPaymentLinkChanges(value: boolean): void {
    const controls = this.formGroup.controls;
    if (!value) controls["PaymentId"].clearValidators();
    else controls["PaymentId"].setValidators(Validators.required);
    controls["PaymentId"].updateValueAndValidity();
  }

  onAutomaticLinksChanges(value: boolean): void {
    if (!value) this.setValue("PrintForOnlineOrder", false);
  }

  onHasPaymentLinkForNewCustomerChanges(value: boolean): void {
    if (!value) this.formGroup.controls["PrintForOnlineOrderForNewCustomer"]?.disable();
    else this.formGroup.controls["PrintForOnlineOrderForNewCustomer"]?.enable();
  }

  FillPaymentMethod(data: Lookup[]) {
    this.PaymentMethod = data;
    this.PaymentMethodLookup = data;
    this.PaymentMethodDefaultList = data;
    this.storage.savePermanentData(data, ClearableCache.PaymentMethodLookUp);
    if (!isNullOrUndefined(this.currentrow.Id) || this.currentrow.Id !== 0) {
      this.currentrow.PaymentMethods?.forEach((x) => {
        if (!x.IsDefault) {
          if (!this.PaymentMethodIdList.some((d) => d === x.PaymentMethodId)) this.PaymentMethodIdList.push(x.PaymentMethodId);
          this.PaymentMethodIdList = this.PaymentMethodIdList?.filter((d) => d !== null);
          this.PaymentMethodDefaultList = this.PaymentMethodDefaultList?.filter((f) => f.Id !== x.PaymentMethodId);
        } else {
          if (!isNullOrUndefined(x.PaymentMethodId) && x.PaymentMethodId !== 0) {
            this.PaymentMethodDefaultId = x.PaymentMethodId;
            this.PaymentMethod = this.PaymentMethod?.filter((f) => f.Id !== x.PaymentMethodId);
          }
        }
      });
    }
    this.setValue("PaymentMethodIdList", this.PaymentMethodIdList);
    this.setValue("PaymentMethodDefaultId", this.PaymentMethodDefaultId);
  }
  FillPrintTemplate(data: Lookup[]) {
    this.PrintTemplate = data;
    this.PrintTemplateLookup = data;
    this.PrintTemplateDefaultList = data;
    if (!isNullOrUndefined(this.model.Id) || this.model.Id !== 0) {
      this.model.PrintTemplates?.forEach((x) => {
        if (!x.IsDefault) {
          if (!this.PrintTemplateIdList.some((d) => d === x.PrintTemplateId)) this.PrintTemplateIdList.push(x.PrintTemplateId);
          this.PrintTemplateIdList = this.PrintTemplateIdList?.filter((d) => d !== null);
          this.PrintTemplateDefaultList = this.PrintTemplateDefaultList?.filter((f) => f.Id !== x.PrintTemplateId);
        } else if (!isNullOrUndefined(x.PrintTemplateId) && x.PrintTemplateId !== 0) {
          this.PrintTemplate = this.PrintTemplate?.filter((f) => f.Id !== x.PrintTemplateId);
        }
      });
    }
    this.setValue("PrintTemplateIdList", this.PrintTemplateIdList);
  }
  FillSalePriceType(data: Lookup[]) {
    this.SalePriceType = data;
    this.SalePriceTypeLookup = data;
    this.SalePriceTypeDefaultList = data;
    if (!isNullOrUndefined(this.currentrow.Id) || this.currentrow.Id !== 0) {
      this.currentrow.SalePriceTypes?.forEach((x) => {
        if (!x.IsDefault) {
          if (!this.SalePriceTypeIdList.some((d) => d === x.SalePriceTypeId)) this.SalePriceTypeIdList.push(x.SalePriceTypeId);
          this.SalePriceTypeIdList = this.SalePriceTypeIdList?.filter((d) => d !== null);
          this.SalePriceTypeDefaultList = this.SalePriceTypeDefaultList?.filter((f) => f.Id !== x.SalePriceTypeId);
        } else {
          this.SalePriceTypeDefaultId = x.SalePriceTypeId;
          this.SalePriceType = this.SalePriceType?.filter((f) => f.Id !== x.SalePriceTypeId);
        }
      });
    }
    this.setValue("SalePriceTypeIdList", this.SalePriceTypeIdList);
    this.setValue("SalePriceTypeDefaultId", this.SalePriceTypeDefaultId);
  }
  getRelative() {
    this.httpCommonService
      .getList("ItemCategory/ReadLookUp")
      .pipe(take(1))
      .subscribe((data: Lookup[]) => {
        if (data) this.FillItemCategory(data);
      });
    this.httpCommonService
      .getList("PaymentMethod/PaymentMethodLookUp/" + this.accountService.authService.currentBranchId)
      .pipe(take(1))
      .subscribe((data: Lookup[]) => {
        if (data) this.FillPaymentMethod(data);
      });

    this.httpCommonService
      .getList("SalePriceType/ReadLookUp")
      .pipe(take(1))
      .subscribe((data: Lookup[]) => {
        if (data) {
          this.storage.savePermanentData(data, ClearableCache.SalePriceType);
          this.FillSalePriceType(data);
        }
      });
    this.httpCommonService
      .getList("PrintTemplate/ReadLookUp")
      .pipe(take(1))
      .subscribe((data: Lookup[]) => {
        if (data) this.FillPrintTemplate(data);
      });
    this.httpCommonService
      .getList("Salon/ReadLookupApi/" + this.accountService.authService.currentBranchId)
      .pipe(take(1))
      .subscribe((data: Lookup[]) => {
        if (data) this.SalonLookupList = data;
      });
    this.httpCommonService
      .getList("DetailLedger/GetPagining")
      .pipe(take(1))
      .subscribe((data: Lookup[]) => {
        if (data) this.DetailLedgerLookupList = data;
      });
  }
  clearForm() {
    this.ItemCategoryIdList = null;
    this.ItemCategoryIdList = [];
    this.PaymentMethodIdList = null;
    this.PaymentMethodIdList = [];
    this.PaymentMethodDefaultId = null;
    this.SalePriceTypeIdList = null;
    this.SalePriceTypeIdList = [];
    this.SalePriceTypeDefaultId = null;
    this.PrintTemplateIdList = null;
    this.PrintTemplateIdList = [];
    this.SalonLookup = [];
    this.model.DaysOfWeek = [];
    this.CustomerCategoriesLookup = [];
    this.ItemCategory = this.ItemCategoryLookup;
    this.PaymentMethod = this.PaymentMethodLookup;
    this.SalePriceType = this.SalePriceTypeLookup;
    this.PrintTemplate = this.PrintTemplateLookup;
  }
  onMasterChanged(event: any) {
    if (!isNullOrUndefined(event.Code)) {
      if (isNullOrUndefined(this.oldSaleMethodNatureId)) {
        // if new mode
        this.oldSaleMethodNatureId = event.Id;
        this.model = null;
        this.model = <SaleMethodBranchModel>{};
      }
      if (!isNullOrUndefined(this.oldSaleMethodNatureId) && event.Id !== this.oldSaleMethodNatureId) {
        // if edit mode and changed SaleMethodCode
        this.SaleMethodNatureCode = event.Code;
        this.oldSaleMethodNatureId = this.SaleMethodNatureId;
        this.model = null;
        this.model = JSON.parse(JSON.stringify(this.oldmodel));
        this.clearForm();
      } else {
        this.SaleMethodNatureId = event.Id;
        this.SaleMethodNatureCode = event.Code;
      }
      switch (event.Code) {
        case SaleMethodNature.Restaurant:
          this.model.IsChangeTheSalesMethod = true;
          this.model.IsSalonFastAccess = true;
          this.model.IsCustomreFastAccess = true;
          this.model.IsWaiterFastAccess = true;
          this.model.IsClubFastAccess = true;
          this.model.IsPaymentLink = true;
          break;
        case SaleMethodNature.FastFood:
          this.model.IsChangeTheSalesMethod = true;
          this.model.IsDriverAssignmentFastAccess = true;
          this.model.IsCustomreFastAccess = true;
          this.model.IsPagerFastAccess = true;
          this.model.IsClubFastAccess = true;
          this.model.IsPaymentLink = true;
          break;
        case SaleMethodNature.Delivery:
          this.model.IsChangeTheSalesMethod = true;
          this.model.IsDriverAssignmentFastAccess = true;
          this.model.IsCustomreFastAccess = true;
          this.model.IsClubFastAccess = true;
          this.model.IsPaymentLink = true;
          break;
      }
      this.addControl();
    }
  }
  onChanged(item: Lookup, detailId: number) {
    if (!isNullOrUndefined(item) && !isNullOrUndefined(detailId)) {
      this.addFilter(item, detailId);
    }
  }
  onAddItem(item: Lookup, detailId: number) {
    if (!isNullOrUndefined(item) && !isNullOrUndefined(detailId)) {
      this.addFilter(item, detailId);
    }
  }
  onClear(detailId: number) {
    switch (detailId) {
      case 0:
        this.ItemCategoriesDefaultList = this.ItemCategoryLookup;
        break;
      case 1:
        this.ItemCategory = this.ItemCategoryLookup;
        break;
      case 2:
        this.PaymentMethodDefaultList = this.PaymentMethodLookup;
        break;
      case 3:
        this.PaymentMethod = this.PaymentMethodLookup;
        break;
      case 4:
        this.SalePriceTypeDefaultList = this.SalePriceTypeLookup;
        break;
      case 5:
        this.SalePriceType = this.SalePriceTypeLookup;
        break;
      case 6:
        this.PrintTemplateDefaultList = this.PrintTemplateLookup;
        break;
      case 7:
        this.PrintTemplate = this.PrintTemplateLookup;
        break;
      default:
        break;
    }
  }
  onRemoveItem(item: any, detailId: number) {
    switch (detailId) {
      case 0:
        this.ItemCategoriesDefaultList.push(item.value);
        this.ItemCategoriesDefaultList = this.ItemCategoriesDefaultList?.filter((f) => f.Id !== null);
        break;
      case 2:
        this.PaymentMethodDefaultList.push(item.value);
        this.PaymentMethodDefaultList = this.PaymentMethodDefaultList?.filter((f) => f.Id !== null);
        break;
      case 4:
        this.SalePriceTypeDefaultList.push(item.value);
        this.SalePriceTypeDefaultList = this.SalePriceTypeDefaultList?.filter((f) => f.Id !== null);
        break;
      case 6:
        this.PrintTemplateDefaultList.push(item.value);
        this.PrintTemplateDefaultList = this.PrintTemplateDefaultList?.filter((f) => f.Id !== null);
        this.model.PrintTemplates.find((x) => x.PrintTemplateId === item.value?.Id).State = RowState.Delete;
        break;
      default:
        break;
    }
  }
  PreprationTimeIsActiveValueChange(value: any) {
    this.IsActivePreparationTime = value;
    if (!value) this.formGroup.controls["PreprationTimeRequired"].setValue(false);
  }
  addFilter(item: Lookup, detailId: number) {
    switch (detailId) {
      case 0:
        this.ItemCategoriesDefaultList = this.ItemCategoriesDefaultList?.filter((f) => f.Id !== item.Id);
        break;
      case 1:
        this.ItemCategory = this.ItemCategoryLookup?.filter((f) => f.Id !== item.Id);
        break;
      case 2:
        this.PaymentMethodDefaultList = this.PaymentMethodDefaultList?.filter((f) => f.Id !== item.Id);
        break;
      case 3:
        this.PaymentMethod = this.PaymentMethodLookup?.filter((f) => f.Id !== item.Id);
        break;
      case 4:
        this.SalePriceTypeDefaultList = this.SalePriceTypeDefaultList?.filter((f) => f.Id !== item.Id);
        break;
      case 5:
        this.SalePriceType = this.SalePriceTypeLookup?.filter((f) => f.Id !== item.Id);
        break;
      case 6:
        this.PrintTemplateDefaultList = this.PrintTemplateDefaultList?.filter((f) => f.Id !== item.Id);
        break;
      case 7:
        this.PrintTemplate = this.PrintTemplateLookup?.filter((f) => f.Id !== item.Id);
        break;
      default:
        break;
    }
  }
  beforupdate() {
    if (this.SaleMethodNatureCode !== this._saleMethodNature.Delivery) this.model.PrintForOnlineOrderForNewCustomer = false;
    if (this.SaleMethodNatureCode !== this._saleMethodNature.Delivery) this.model.HasPaymentLinkForNewCustomer = false;
    if (!this.model?.Id && this.accountService.authService.currentBranch.AccessToAllBranches) {
      this.Branches = this.Branches?.filter((x) => x.IsActive);
      if (!this.model?.Branches) this.model.Branches = [];
      this.Branches?.forEach((x) => {
        this.model.Branches.push(x.Id);
      });
      this.model.AllBranches = Object.assign([], this.model.Branches);
    } else {
      this.model.Branches = null;
    }
    if (!this.model.ItemCategories) this.model.ItemCategories = [];
    if (!this.model.PaymentMethods) this.model.PaymentMethods = [];
    if (!this.model.PrintTemplates) this.model.PrintTemplates = [];
    if (!this.model.SalePriceTypes) this.model.SalePriceTypes = [];
    if (!this.model.Salons) this.model.Salons = [];
    if (!this.model.CustomerCategories) this.model.CustomerCategories = [];

    this.ItemCategoryIdList = this.formGroup.controls["ItemCategoryIdList"]?.value;
    this.PaymentMethodIdList = this.formGroup.controls["PaymentMethodIdList"]?.value;
    this.SalePriceTypeIdList = this.formGroup.controls["SalePriceTypeIdList"]?.value;
    this.PrintTemplateIdList = this.formGroup.controls["PrintTemplateIdList"]?.value;
    this.SalonLookup = this.formGroup.controls["SalonLookup"]?.value;
    this.CustomerCategoriesLookup = this.formGroup.controls["CustomerCategoriesLookup"]?.value;

    this.ItemCategoriesDefaultId = this.formGroup.controls["ItemCategoriesDefaultId"]?.value;
    this.PaymentMethodDefaultId = this.formGroup.controls["PaymentMethodDefaultId"]?.value;
    this.SalePriceTypeDefaultId = this.formGroup.controls["SalePriceTypeDefaultId"]?.value;
    this.model.SaleMethodId = this.formGroup.controls["SaleMethodId"]?.value;
    this.model.HasHappyHour = this.formGroup.controls["HasHappyHour"]?.value;
    const DaysOfWeek = this.formGroup.controls["DaysOfWeek"]?.value;
    this.model.Discount = this.formGroup.controls["Discount"]?.value;
    this.model.HappyHourStart = this.formGroup.controls["HappyHourStart"]?.value;
    this.model.HappyHourEnd = this.formGroup.controls["HappyHourEnd"]?.value;
    this.model.HappyHourFromDate = this.formGroup.controls["HappyHourFromDate"]?.value;
    this.model.HappyHourToDate = this.formGroup.controls["HappyHourToDate"]?.value;
    this.model.HappyHourToDate = this.formGroup.controls["HappyHourToDate"]?.value;
    this.model.FreeService = this.formGroup.controls["FreeService"]?.value;
    this.model.FreeShipping = this.formGroup.controls["FreeShipping"]?.value;
    this.model.DaysOfWeek = this.formGroup.controls["DaysOfWeek"]?.value;
    this.formGroup.controls["IsDiscountPercent"].setValue(this.model.IsDiscountPercent);
    if (DaysOfWeek) this.formGroup.controls["DaysOfWeek"].setValue(DaysOfWeek.join());
    this.model.HasKeyboardOrder = this.formGroup.controls["HasKeyboardOrder"]?.value;
    this.model.HasDelino = this.formGroup.controls["HasDelino"]?.value;
    this.model.HasSnap = this.formGroup.controls["HasSnap"]?.value;
    if (this.model.ItemCategories) {
      this.model.ItemCategories?.forEach((x) => {
        if (!this.ItemCategoryIdList?.some((d) => d === x.CategoryId) || this.ItemCategoriesDefaultId !== x.CategoryId) x.State = RowState.Delete;
      });
    }
    if (this.model.PaymentMethods) {
      this.model.PaymentMethods?.forEach((x) => {
        if (!this.PaymentMethodIdList?.some((d) => d === x.PaymentMethodId) || this.PaymentMethodDefaultId !== x.PaymentMethodId)
          x.State = RowState.Delete;
      });
    }
    if (this.model.SalePriceTypes) {
      this.model.SalePriceTypes?.forEach((x) => {
        if (!this.SalePriceTypeIdList?.some((d) => d === x.SalePriceTypeId) || this.SalePriceTypeDefaultId !== x.SalePriceTypeId)
          x.State = RowState.Delete;
      });
    }

    if (this.model.Salons) {
      this.model.Salons?.forEach((x) => {
        if (!this.SalonLookup.some((d) => d === x.SalonId)) x.State = RowState.Delete;
      });
    }
    if (this.model.CustomerCategories) {
      this.model.CustomerCategories?.forEach((x) => {
        if (!this.CustomerCategoriesLookup?.some((d) => d === x.CategoryId)) x.State = RowState.Delete;
      });
    }

    this.ItemCategoryIdList?.forEach((x) => {
      if (!this.model.ItemCategories?.some((d) => d.CategoryId === x && d.State !== RowState.Delete && d.State !== RowState.Detached)) {
        const doc: SaleMethodBranchItemCategory = new SaleMethodBranchItemCategory();
        doc.CategoryId = x;
        doc.State = RowState.New;
        this.model.ItemCategories.push(doc);
      }
    });
    if (
      !isNullOrUndefined(this.ItemCategoriesDefaultId) &&
      !this.model.ItemCategories?.some(
        (d) => d.CategoryId === this.ItemCategoriesDefaultId && d.IsDefault && d.State !== RowState.Delete && d.State !== RowState.Detached
      )
    ) {
      const doc: SaleMethodBranchItemCategory = new SaleMethodBranchItemCategory();
      doc.CategoryId = this.ItemCategoriesDefaultId;
      doc.IsDefault = true;
      doc.State = RowState.New;
      this.model.ItemCategories.push(doc);
    }
    this.PaymentMethodIdList?.forEach((x) => {
      if (!this.model.PaymentMethods?.some((d) => d.PaymentMethodId === x && d.State !== RowState.Delete && d.State !== RowState.Detached)) {
        const doc: SaleMethodBranchPaymentMethod = new SaleMethodBranchPaymentMethod();
        doc.PaymentMethodId = x;
        doc.State = RowState.New;
        this.model.PaymentMethods.push(doc);
      }
    });
    if (
      this.PaymentMethodDefaultId &&
      !this.model.PaymentMethods?.some(
        (d) => d.PaymentMethodId === this.PaymentMethodDefaultId && d.State !== RowState.Delete && d.State !== RowState.Detached
      )
    ) {
      const doc: SaleMethodBranchPaymentMethod = new SaleMethodBranchPaymentMethod();
      doc.PaymentMethodId = this.PaymentMethodDefaultId;
      doc.IsDefault = true;
      doc.State = RowState.New;
      this.model.PaymentMethods.push(doc);
    }
    this.PrintTemplateIdList?.forEach((x) => {
      if (!this.model.PrintTemplates?.some((d) => d.PrintTemplateId === x && d.State !== RowState.Delete && d.State !== RowState.Detached)) {
        const doc: SaleMethodBranchPrintTemplate = new SaleMethodBranchPrintTemplate();
        doc.PrintTemplateId = x;
        doc.State = RowState.New;
        this.model.PrintTemplates.push(doc);
      }
    });

    this.SalePriceTypeIdList?.forEach((x) => {
      if (!this.model.SalePriceTypes.some((d) => d.SalePriceTypeId === x && d.State !== RowState.Delete && d.State !== RowState.Detached)) {
        const doc: SaleMethodBranchSalePriceType = new SaleMethodBranchSalePriceType();
        doc.SalePriceTypeId = x;
        doc.State = RowState.New;
        this.model.SalePriceTypes.push(doc);
      }
    });
    if (
      !isNullOrUndefined(this.SalePriceTypeDefaultId) &&
      !this.model.SalePriceTypes?.some(
        (d) => d.SalePriceTypeId === this.SalePriceTypeDefaultId && d.State !== RowState.Delete && d.State !== RowState.Detached
      )
    ) {
      const doc: SaleMethodBranchSalePriceType = new SaleMethodBranchSalePriceType();
      doc.SalePriceTypeId = this.SalePriceTypeDefaultId;
      doc.IsDefault = true;
      doc.State = RowState.New;
      this.model.SalePriceTypes.push(doc);
    }
    this.SalonLookup?.forEach((x) => {
      if (!this.model.Salons?.some((d) => d.SalonId === x && d.State !== RowState.Delete && d.State !== RowState.Detached)) {
        const doc: SaleMethodBranchSalon = new SaleMethodBranchSalon();
        doc.SalonId = x;
        doc.State = RowState.New;
        this.model.Salons.push(doc);
      }
    });
    this.CustomerCategoriesLookup?.forEach((x) => {
      if (!this.model.CustomerCategories?.some((d) => d.CategoryId === x && d.State !== RowState.Delete && d.State !== RowState.Detached)) {
        const doc: SaleMethodBranchCustomerCategory = new SaleMethodBranchCustomerCategory();
        doc.CategoryId = x;
        doc.State = RowState.New;
        this.model.CustomerCategories.push(doc);
      }
    });
    this.Branches = this.Branches?.filter((x) => x.IsActive);

    this.model.SaleMethodTitle = this.SaleMethodList?.find((f) => f.Id === this.formGroup.controls["SaleMethodId"].value)?.Title;
    this.setValue("SaleMethodTitle", this.model.SaleMethodTitle);

    if (this.model.Id && this.OriginalApplyTax !== this.formGroup.controls['ApplyTax'].value) {
      this.model.TaxApplyIsChanged = true;
      this.setValue("TaxApplyIsChanged", true);
    }
  }

  isValid() {
    let flag: boolean = true;
    if (
      this.SaleMethodNatureCode == SaleMethodNature.Delivery &&
      this.formGroup.controls["Discount"].value > 0 &&
      this.formGroup.controls["FreeShipping"].value
    ) {
      flag = false;
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NotPossibleFreeAndDiscountedFaresDeactivateOneThem")}`,
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (this.formGroup.controls["HasDelino"].value) {
      this.delinoActiveControl.forEach((element) => {
        if (element.HasDelino && this.model.SaleMethodId != element.SaleMethodId) {
          flag = false;
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.SALE.SaleMethod.DelinoActiveAnotherSalesMode"),
            this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
          );
        }
      });
    }
    if (
      this.formGroup.controls["HasHappyHour"]?.value &&
      this.formGroup.controls["Discount"]?.value == null &&
      !(this.formGroup.controls["FreeService"]?.value || this.formGroup.controls["FreeShipping"]?.value)
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.ChooseHourlyDiscountMandatoryDiscountAmount"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (
      this.formGroup.controls["HasHappyHour"]?.value &&
      this.formGroup.controls["Discount"]?.value == null &&
      (this.formGroup.controls["FreeService"]?.value || this.formGroup.controls["FreeShipping"]?.value)
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.MinimumDiscountAmountZero"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (this.formGroup.controls["HasHappyHour"]?.value && !this.formGroup.controls["HappyHourStart"]?.value) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.HourlyDiscountMandatoryStartingTimeDiscount"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (
      this.formGroup.controls["Discount"]?.value == 0 &&
      !(this.formGroup.controls["FreeService"]?.value || this.formGroup.controls["FreeShipping"]?.value)
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.MakeRentServiceFree"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (this.formGroup.controls["HasHappyHour"]?.value && !this.formGroup.controls["HappyHourEnd"]?.value) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.ChooseHourlyDiscountMandatoryEndTimeDiscount"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (this.formGroup.controls["WaiterIsRequired"]?.value && !this.formGroup.controls["ShowWaiterName"]?.value) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.HostessMandatoryChoosingNameHostessMandatory"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (!this.formGroup.controls["SaleMethodId"]?.value) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NatureSaleEntered"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (this.formGroup.controls["NumberOfGuestsIsRequired"]?.value && !this.formGroup.controls["ShowNumberOfGuests"]?.value) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NumberOfPeopleMandatory"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (this.formGroup.controls["TableIsRequired"]?.value && !this.formGroup.controls["ShowSalonName"]?.value) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.MandatorySelectionTable"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (this.formGroup.controls["HasPaymentLink"]?.value && !this.formGroup.controls["PaymentId"].value) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.PaymentMethodRequired"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    this.ItemCategoryIdList = this.formGroup.controls["ItemCategoryIdList"]?.value;
    if (
      flag &&
      this.ItemCategoryLookup &&
      this.ItemCategoryIdList &&
      this.ItemCategoryLookup?.length === this.ItemCategoryIdList?.length &&
      this.ItemCategoryIdList?.length > 0
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NotPossibleSelectProductGroupsUnauthorized"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }

    this.PaymentMethodIdList = this.formGroup.controls["PaymentMethodIdList"]?.value;
    this.SalePriceTypeIdList = this.formGroup.controls["SalePriceTypeIdList"]?.value;
    this.PrintTemplateIdList = this.formGroup.controls["PrintTemplateIdList"]?.value;
    if (
      flag &&
      this.PaymentMethodIdList &&
      this.PaymentMethodLookup &&
      this.PaymentMethodLookup?.length === this.PaymentMethodIdList?.length &&
      this.PaymentMethodIdList?.length > 0
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NotPossibleSelectAllPaymentMethods"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (
      flag &&
      this.SalePriceTypeIdList &&
      this.SalePriceTypeLookup &&
      this.SalePriceTypeLookup?.length === this.SalePriceTypeIdList?.length &&
      this.SalePriceTypeIdList?.length > 0
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NotPossibleSalesPriceTypesUnauthorized"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    if (
      flag &&
      this.PrintTemplateIdList &&
      this.PrintTemplateLookup &&
      this.PrintTemplateLookup?.length === this.PrintTemplateIdList?.length &&
      this.PrintTemplateIdList?.length > 0
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NotPossibleSelectPrintPatternsUnauthorized"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }
    this.SalonLookup = this.formGroup.controls["SalonLookup"]?.value;

    if (
      flag &&
      this.SalonLookup &&
      this.SalonLookupList &&
      this.SalonLookupList?.length === this.SalonLookup?.length &&
      this.SalonLookupList?.length > 0
    ) {
      flag = false;
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.NotPossibleSelectHallsUnauthorized"),
        this.translate("ClientApp.FrontOffice.SALE.SaleMethod.Error")
      );
    }

    if (!flag) this.selectorService.submitted$.next(true);
    return flag;
  }
  SaleMethodChange($event) {
    this.SaleMethodNatureCode = $event.Code;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;

    if (this.activeTabTitle === this.translate("ClientApp.FrontOffice.SALE.SaleMethod.PaymentLink")) {
      this.getPaymentMethodData();
    }
    if (this.activeTabTitle === this.translate("ClientApp.FrontOffice.SALE.SaleMethod.IsClubFastAccess")) {
      if (!this.model.HasSnap) {
        this.formGroup.controls["AutoApplySnap"]?.disable();
      } else {
        this.formGroup.controls["AutoApplySnap"]?.enable();
      }
    }
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  controlDelino() {
    this.delinoActiveControl.forEach((element) => {
      if (element.HasDelino) {
        this.controlIdDelino = element.SaleMethodId;
      }
    });
  }
  getAccessDelino() {
    this.httpCommonService
      .get("Branch/GetById/" + this.accountService.authService.currentBranch?.Id)
      .pipe(take(1))
      .subscribe(
        (x: Branch) => {
          if (x.HasOrderOnline === true) this.HasAccessOrderOnline = true;
          else this.HasAccessOrderOnline = false;
        },
        (error) => console.log(error)
      );
  }
  controlActiveDelino() {
    this.httpCommonService
      .get("SaleMethodBranch/GetAllSaleMethodBranch")
      .pipe(take(1))
      .subscribe((data: SaleMethodBranchModel[]) => {
        this.delinoActiveControl = data;
      });
  }
  populateBranch() {
    if (this.accountService.authService.currentBranch.AccessToAllBranches) {
      this.isAccessToAllBranches = true;
      this.httpCommonService
        .getList("Branch/ReadLookUp")
        .pipe(take(1))
        .subscribe(
          (data: Lookup[]) => {
            if (!this.Branches) this.Branches = [];
            data?.forEach((ele: Lookup) => {
              let entity = <BranchList>{};
              entity.Title = ele.Title;
              entity.Id = ele.Id;
              entity.IsActive = true;
              this.Branches.push(entity);
            });
            this.branchShow = true;
            this.cd.markForCheck();
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  private getPaymentMethodData(): void {
    if (!this.PaymentMethodData.length) {
      this.httpCommonService
        .getList("PaymentMethod/PaymentMethodLookUp/" + this.accountService.authService.currentBranchId)
        .pipe(take(1))
        .subscribe((res: any[]) => {
          this.PaymentMethodData = res.filter((x) => x.PaymentMethodCode === PaymentMethodType.Internet);
        });
    }
  }
  //DiscountFocus
  onDiscountfocus() {
    if (this.formGroup.controls["Discount"].value === "0" || this.formGroup.controls["Discount"].value === 0) {
      this.setValue("Discount", 0);
    }
  }
  //اعمال تخفیف
  applyDiscount(value: string, isPercent: boolean) {
    let output = null;
    if (isPercent != null) {
      this.model.IsDiscountPercent = isPercent;
      this.model.Discount = null;
      this.formGroup.controls["Discount"].setValue(null);
      return;
    }
    let discountValue: number = this.formGroup.controls["Discount"].value;
    if (this.model.IsDiscountPercent) {
      discountValue = this.formGroup.controls["Discount"].value ? Number(this.formGroup.controls["Discount"].value) : null;
      this.model.Discount = discountValue;
      this.model.IsDiscountPercent = true;

      if (Number(value) > 100) {
        this.formGroup.controls["Discount"].setValue(100);
      } else {
        output = Number(value) ? Number(value) : this.authservice.currentUser.PercentDiscount;
        discountValue = output;
      }
    } else {
      if (this.authservice.currentUser.RialDiscount > 0) {
        output = Number(value) ? Number(value) : this.authservice.currentUser.RialDiscount;
        discountValue = output;
      }
      this.model.IsDiscountPercent = false;
      this.model.Discount = discountValue;
    }
  }

  //Clear Discount
  clearDiscount() {
    this.formGroup.controls["Discount"].setValue(0);
    this.model.Discount = null;
  }

  focus(id: string) {
    const input: HTMLInputElement = document.getElementById(id) as HTMLInputElement;
    if (input) {
      input.focus();
      input.select();
    }
  }
}
